<div class="content-block history">
    <h2 class="screen-reader-text">Parcel History</h2>
    <div class="title-with-options with-tabs bottom-line">
        <mat-tab-group class="title-tabs" (selectedTabChange)="onHistoryTabChange($event.index)">
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="mat-h2" @retainAnimation>Unpaid Bills</div>
                </ng-template>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <div class="mat-h2" @retainAnimation>All Bills</div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
        <div class="option-buttons">
            <ng-container *ngIf="printParcelHistoryAllowed$ | async">
                <ng-template #desktopPrintHistoryButtonContent>
                    <ng-container *ngIf="loaded; else historyPrintPlaceholder">
                        <span class="label">Print History</span>
                        <mat-icon class="right">print</mat-icon>
                    </ng-container>
                    <ng-template #historyPrintPlaceholder>
                        <egov-text-ui-placeholder class="label"> Print History </egov-text-ui-placeholder>
                        <mat-icon class="right">
                            <egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder>
                        </mat-icon>
                    </ng-template>
                </ng-template>
                <ng-template #phonePrintHistoryButtonContent>
                    <mat-icon *ngIf="loaded"> print </mat-icon>
                    <mat-icon *ngIf="!loaded">
                        <egov-shape-ui-placeholder shape="circle"></egov-shape-ui-placeholder>
                    </mat-icon>
                </ng-template>
                <ng-container *ngIf="historyPrintUrl">
                    <a
                        *ngIf="(viewport.phone$ | async) === false; else printHistoryButtonPhone"
                        mat-button
                        class="print"
                        [href]="historyPrintUrl"
                        target="_blank"
                    >
                        <ng-container *ngTemplateOutlet="desktopPrintHistoryButtonContent"></ng-container>
                    </a>
                    <ng-template #printHistoryButtonPhone>
                        <app-icon-button [href]="historyPrintUrl">
                            <ng-container *ngTemplateOutlet="phonePrintHistoryButtonContent"></ng-container>
                        </app-icon-button>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="!historyPrintUrl">
                    <button
                        *ngIf="!(viewport.phone$ | async); else printHistoryButtonPhone"
                        mat-button
                        class="print"
                        title="Unavailable for this bill"
                        disabled
                    >
                        <ng-container *ngTemplateOutlet="desktopPrintHistoryButtonContent"></ng-container>
                    </button>
                    <ng-template #printHistoryButtonPhone>
                        <app-icon-button [egovTooltip]="printHistoryUnavailable">
                            <ng-template #printHistoryUnavailable> Unavailable for this bill </ng-template>
                            <ng-container *ngTemplateOutlet="phonePrintHistoryButtonContent"></ng-container>
                        </app-icon-button>
                    </ng-template>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <div class="content-pane no-padding">
        <!-- Templates -->

        <ng-template #billBalance let-bill let-align="align">
            <ng-container *ngIf="bill">
                <ng-container *ngIf="!bill.balanceViewBlocked; else balanceViewBlockedAmount">
                    {{ bill.due | currency }}
                </ng-container>
                <ng-template #balanceViewBlockedAmount>
                    <span
                        class="not-available annotated-value"
                        [egovTooltip]="balanceViewBlockedTooltip"
                        (click)="platform.touchIsMainInput$.value && $event.stopPropagation()"
                    >
                        <ng-template #balanceViewBlockedTooltip>
                            <div style="max-width: 350px" [innerHTML]="(blockMessages$ | async)?.unavailableBalance | MarkdownToHtml"></div>
                        </ng-template>
                        <mat-icon *ngIf="align !== 'left'">info</mat-icon>
                        <span class="unimportant-text">N / A</span>
                        <mat-icon *ngIf="align === 'left'">info</mat-icon>
                    </span>
                </ng-template>
            </ng-container>
            <egov-text-ui-placeholder *ngIf="!bill" length="6"></egov-text-ui-placeholder>
        </ng-template>

        <ng-template #paymentPrintReceipt let-payment>
            <app-icon-button
                *ngIf="(displayPaymentHistory$ | async) && (displayPrintReceiptButton$ | async)"
                [disabled]="!payment.printUrl"
                [title]="getPaymentPrintReceiptTitle(payment)"
                (click)="paymentReceiptButtonClickHandler(payment, $event)"
            >
                receipt
            </app-icon-button>
        </ng-template>

        <ng-template #paymentTags let-payment>
            <ul class="payment-tags">
                <li *ngIf="payment.isPrePayment">Pre-Payment</li>
            </ul>
        </ng-template>

        <!-- Templates over -->

        <p class="no-history" *ngIf="(historyBillsAndPayments$ | async) && !(historyBillsAndPayments$ | async)!.length; else actualResults">
            {{ (historyUnpaidOnly$ | async) ? "No unpaid bills" : "This parcel doesn't have a history" }}
        </p>
        <ng-template #actualResults>
            <table *ngIf="!(viewport.tablet$ | async); else responsiveHistory" class="styled bills borderless wide">
                <thead>
                    <tr>
                        <th class="tax-year">
                            <div class="content">Year</div>
                        </th>
                        <th>
                            <div class="content">Owner</div>
                        </th>
                        <th class="numeric single-line">
                            <div class="content">Due</div>
                        </th>
                        <ng-container *ngIf="displayPaymentHistory$ | async">
                            <th *ngIf="displayReceiptId$ | async">
                                <div class="content">Receipt</div>
                            </th>
                            <th>
                                <div class="content">Payor</div>
                            </th>
                            <th class="single-line">
                                <div class="content">Paid On</div>
                            </th>
                        </ng-container>
                        <th class="single-line">
                            <div class="content">Status</div>
                        </th>
                        <th class="numeric single-line">
                            <div class="content">Paid</div>
                        </th>
                        <th class="actions right single-line">
                            <div class="content">Actions</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of (historyBillsAndPayments$ | async) || [null]; trackBy: historyBillsAndPaymentsTrackBy">
                        <tr
                            *ngIf="!item || isBill(item)"
                            [class.clickable]="item && item.taxYear !== taxYear"
                            [routerLink]="(item && item.taxYear !== taxYear && (routerLink$(item.id) | async)) || undefined"
                            [egovClickOnKey]
                            [class]="item ? getStatusForBill(item) : null"
                            [class.highlight-on-hover]="item && item.taxYear !== taxYear"
                            [class.current]="item && item.taxYear === taxYear"
                        >
                            <td class="tax-year">
                                <ppt-tax-year [bill]="item"></ppt-tax-year>
                            </td>
                            <td>
                                <ppt-owner [bill]="item"></ppt-owner>
                            </td>
                            <td class="numeric single-line">
                                <ng-container *ngTemplateOutlet="billBalance; context: { $implicit: item }"></ng-container>
                            </td>
                            <ng-container *ngIf="displayPaymentHistory$ | async">
                                <ng-container *ngIf="!item || item?.payments?.length < 1">
                                    <td *ngIf="displayReceiptId$ | async">
                                        <span class="unimportant-text">
                                            <ppt-receipt-number *ngIf="item" [payment]="item"></ppt-receipt-number>
                                            <egov-text-ui-placeholder *ngIf="!item" length="7"></egov-text-ui-placeholder>
                                        </span>
                                    </td>
                                    <td>
                                        <span class="unimportant-text">
                                            <ppt-payor *ngIf="item" [payment]="item"></ppt-payor>
                                            <egov-text-ui-placeholder *ngIf="!item" length="7"></egov-text-ui-placeholder>
                                        </span>
                                    </td>
                                    <td class="single-line">
                                        <span class="unimportant-text">
                                            <ppt-paid-on *ngIf="item" [payment]="item"></ppt-paid-on>
                                            <egov-text-ui-placeholder *ngIf="!item" length="7"></egov-text-ui-placeholder>
                                        </span>
                                    </td>
                                </ng-container>
                                <ng-container *ngIf="item && item.payments?.length === 1">
                                    <td *ngIf="displayReceiptId$ | async">
                                        <span>
                                            <ppt-receipt-number [payment]="item.payments[0]"></ppt-receipt-number>
                                        </span>
                                    </td>
                                    <td>
                                        <span>
                                            <ppt-payor [payment]="item.payments[0]"></ppt-payor>
                                        </span>
                                    </td>
                                    <td class="single-line">
                                        <span>
                                            <ppt-paid-on [payment]="item.payments[0]"></ppt-paid-on>
                                        </span>
                                    </td>
                                </ng-container>
                                <ng-container *ngIf="item && item?.payments?.length > 1">
                                    <td [attr.colspan]="(displayReceiptId$ | async) ? 3 : 2" class="expand single-line">
                                        <button mat-flat-button (click)="receiptsToggleHandler($event, item)">
                                            <span *ngIf="(billsWithPaymentsExpanded$ | async)?.has(item.id) === false"> Show payments </span>
                                            <span *ngIf="(billsWithPaymentsExpanded$ | async)?.has(item.id) !== false"> Hide payments </span>
                                            <mat-icon *ngIf="(billsWithPaymentsExpanded$ | async)?.has(item.id) === false" class="expand-icon">
                                                expand_more
                                            </mat-icon>
                                            <mat-icon *ngIf="(billsWithPaymentsExpanded$ | async)?.has(item.id) !== false" class="collapse-icon">
                                                expand_less
                                            </mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                            </ng-container>
                            <td class="single-line">
                                <ppt-bill-status [bill]="item"></ppt-bill-status>
                            </td>
                            <td class="numeric single-line">
                                <ppt-bill-paid [bill]="item"></ppt-bill-paid>
                            </td>
                            <td class="actions right align-middle single-line">
                                <div class="action-buttons">
                                    <ng-container *ngIf="(displayPaymentHistory$ | async) !== false && (displayPrintReceiptButton$ | async)">
                                        <app-icon-button
                                            [placeholder]="!item"
                                            [disabled]="shouldBillHaveItsReceiptButtonDisabled(item)"
                                            [title]="getPrintReceiptTitle(item)"
                                            (click)="billReceiptButtonClickHandler($event, item)"
                                        >
                                            receipt
                                        </app-icon-button>
                                    </ng-container>
                                    <ng-container *ngIf="(displayPrintBillButton$ | async) !== false">
                                        <app-icon-button
                                            [placeholder]="!item"
                                            [disabled]="!item?.printUrl"
                                            [title]="item?.printUrl ? 'Print Bill' : 'This bill isn\'t available for printing.'"
                                            (click)="printBill($event, item)"
                                        >
                                            print
                                        </app-icon-button>
                                    </ng-container>
                                    <div [egovTooltip]="item?.paymentBlocked ? paymentBlockedTooltip : null">
                                        <ng-template #paymentBlockedTooltip>
                                            <!--                                            Removed as part of the updates from EGOVD-13572 to allow multi block messages ---->
                                            <div style="max-width: 350px" [innerHTML]="(blockMessages$ | async)?.paymentForbidden | MarkdownToHtml"></div>
                                            <div *ngFor="let msg of item?.blockFlags" style="max-width: 350px;">
                                                {{ msg }}
                                            </div>
                                        </ng-template>
                                        <app-icon-button
                                            [placeholder]="!item"
                                            [title]="item?.title || ''"
                                            [disabled]="!item?.isItselfPayable"
                                            (click)="toggleBillInCart(item, $event)"
                                            [spinner]="item?.toggling"
                                        >
                                            {{ item && (billIsInCart$(item) | async) ? "remove_shopping_cart" : "add_shopping_cart" }}
                                        </app-icon-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="(displayPaymentHistory$ | async) && isPayment(item)" class="payment">
                            <td colspan="3">
                                <ng-container *ngTemplateOutlet="paymentTags; context: { $implicit: item }"></ng-container>
                            </td>
                            <td *ngIf="displayReceiptId$ | async">
                                <ppt-receipt-number [payment]="item"></ppt-receipt-number>
                            </td>
                            <td>
                                <ppt-payor [payment]="item"></ppt-payor>
                            </td>
                            <td class="single-line">
                                <ppt-paid-on [payment]="item"></ppt-paid-on>
                            </td>
                            <td class="single-line">
                                <ppt-payment-status [payment]="item"></ppt-payment-status>
                            </td>
                            <td class="numeric single-line">
                                <ppt-payment-amount [payment]="item"></ppt-payment-amount>
                            </td>
                            <td class="actions right align-middle single-line">
                                <div class="action-buttons">
                                    <ng-container *ngTemplateOutlet="paymentPrintReceipt; context: { $implicit: item }"></ng-container>
                                    <app-icon-button *ngIf="(displayPrintBillButton$ | async) !== false" class="invisible"></app-icon-button>
                                    <app-icon-button class="invisible"></app-icon-button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="1"></td>
                        <td class="right single-line unimportant-text"> Total Due </td>
                        <td class="numeric single-line">
                            <ppt-account-balance [accountNumber]="accountNumber$ | async" [showYears]="false" [showDueWord]="false"></ppt-account-balance>
                        </td>
                        <td class="total-actions actions right single-line" [attr.colspan]="(displayPaymentHistory$ | async) ? 6 : 3">
                            <div class="option-buttons">
                                <div class="add-all" [class.remove]="isAccountInCart$ | async" [class.updating]="updatingAccountCartStatus$ | async">
                                    <button
                                        mat-button
                                        class="add-to-cart"
                                        [title]="addAccountToOrRemoveFromCartTitle$ | async"
                                        (click)="toggleAccountInCart()"
                                        [disabled]="!(addAllEnabled$ | async)"
                                    >
                                        <span class="label text">Add all</span>
                                        <mat-icon class="right">
                                            <span class="actual-icon">add_shopping_cart</span>
                                            <app-action-button-spinner *ngIf="updatingAccountCartStatus$ | async"></app-action-button-spinner>
                                            <app-warned *ngIf="(showAddAllWarningIcon$ | async) && !(updatingAccountCartStatus$ | async)"></app-warned>
                                        </mat-icon>
                                    </button>
                                    <button
                                        mat-button
                                        class="remove-from-cart"
                                        [title]="addAccountToOrRemoveFromCartTitle$ | async"
                                        (click)="toggleAccountInCart()"
                                        [disabled]="!(addAllEnabled$ | async)"
                                    >
                                        <span class="label text">Remove all</span>
                                        <mat-icon class="right">
                                            <span class="actual-icon">remove_shopping_cart</span>
                                            <app-action-button-spinner *ngIf="updatingAccountCartStatus$ | async"></app-action-button-spinner>
                                            <app-warned *ngIf="(showAddAllWarningIcon$ | async) && !(updatingAccountCartStatus$ | async)"></app-warned>
                                        </mat-icon>
                                    </button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>

            <!-- Responsive -->

            <ng-template #responsiveHistory>
                <app-show-more>
                    <table class="styled borderless narrow parcel-result-list">
                        <thead>
                            <tr>
                                <th class="tax-year">
                                    <div class="content">Year</div>
                                </th>
                                <th class="status">
                                    <div class="content">Status</div>
                                </th>
                                <th class="owner">
                                    <div class="content">Owner</div>
                                </th>
                                <th class="amount numeric">
                                    <div class="content">Due</div>
                                </th>
                                <th class="actions right">
                                    <div class="content"></div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let bill of (filteredHistory$ | async) || nullLists.get(4); trackBy: filteredHistoryTrackBy">
                                <tr
                                    class="bill"
                                    [class.clickable]="bill?.taxYear !== taxYear"
                                    [routerLink]="(bill && bill?.taxYear !== taxYear && (routerLink$(bill.id) | async)) || undefined"
                                    [egovClickOnKey]
                                    [class.highlight-on-hover]="bill?.taxYear !== taxYear"
                                    [class.current]="bill && bill?.taxYear === taxYear"
                                    [class.showing-details]="
                                        ((viewport.phone$ | async) || ((displayPaymentHistory$ | async) && bill?.payments?.length)) && showingDetails(bill)
                                    "
                                >
                                    <td class="tax-year data-field">
                                        <ppt-tax-year [bill]="bill"></ppt-tax-year>
                                    </td>
                                    <td class="status data-field">
                                        <div class="ellipsed">
                                            <div class="ellipsed-content" [class.loading]="!bill">
                                                <ppt-bill-status [bill]="bill"></ppt-bill-status>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="owner data-field">
                                        <div class="ellipsed">
                                            <div class="ellipsed-content" [class.loading]="!bill">
                                                <ppt-owner [bill]="bill"></ppt-owner>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="amount numeric data-field">
                                        <ng-container *ngTemplateOutlet="billBalance; context: { $implicit: bill }"></ng-container>
                                    </td>
                                    <td class="actions right align-middle">
                                        <div class="action-buttons" [style.margin-right]="'4px'">
                                            <ng-template #paymentBlockedTooltip>
                                                <div
                                                    style="min-width: 220px; max-width: 350px"
                                                    [innerHTML]="(blockMessages$ | async)?.paymentForbidden | MarkdownToHtml"
                                                ></div>
                                            </ng-template>
                                            <mat-menu #parcelHistoryItemMenu="matMenu" xPosition="before" overlapTrigger>
                                                <button
                                                    *ngIf="(viewport.phone$ | async) || ((displayPaymentHistory$ | async) && bill?.payments?.length)"
                                                    mat-menu-item
                                                    (click)="toggleDetailsForBill(bill)"
                                                >
                                                    {{ !showingDetails(bill) ? "Show details" : "Hide Details" }}
                                                </button>
                                                <mat-divider></mat-divider>
                                                <button
                                                    *ngIf="bill?.due"
                                                    mat-menu-item
                                                    [appModal]="bill?.paymentBlocked ? paymentBlockedTooltip : undefined"
                                                    (click)="toggleBillInCart(bill)"
                                                >
                                                    {{ !(billIsInCart$(bill) | async) ? "Add to Cart" : "Remove from Cart" }}
                                                    <app-warned *ngIf="false"></app-warned>
                                                </button>
                                                <mat-divider></mat-divider>
                                                <button
                                                    *ngIf="(displayPrintBillButton$ | async) !== false"
                                                    mat-menu-item
                                                    [disabled]="!bill?.printUrl"
                                                    (click)="printBill($event, bill)"
                                                >
                                                    {{ bill?.printUrl ? "Print Bill" : "Bill Not Available" }}
                                                </button>
                                                <button
                                                    *ngIf="(displayPaymentHistory$ | async) && (displayPrintReceiptButton$ | async)"
                                                    mat-menu-item
                                                    [disabled]="shouldBillHaveItsReceiptButtonDisabled(bill)"
                                                    (click)="billReceiptButtonClickHandler($event, bill)"
                                                >
                                                    Print Receipt
                                                </button>
                                            </mat-menu>
                                            <app-icon-button
                                                [placeholder]="!bill"
                                                [moreIconAtTheEnd]="true"
                                                [matMenuTriggerFor]="parcelHistoryItemMenu"
                                                (click)="$event.stopPropagation()"
                                            >
                                                more_vert
                                            </app-icon-button>
                                        </div>
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="((viewport.phone$ | async) || ((displayPaymentHistory$ | async) && bill?.payments?.length)) && showingDetails(bill)"
                                    class="details"
                                >
                                    <td [attr.colspan]="!(viewport.phone$ | async) ? 5 : 4">
                                        <div class="owner">
                                            <h4 class="label">Owner</h4>
                                            <ppt-owner [bill]="bill"></ppt-owner>
                                        </div>
                                        <div class="payments" *ngIf="(displayPaymentHistory$ | async) && bill?.payments?.length">
                                            <h4>
                                                {{ bill.payments.length > 1 ? "Payments" : "Payment" }}
                                            </h4>
                                            <div class="payments-table-container">
                                                <table class="payments-table styled borderless" [class.showing-receipt-id]="!!(displayReceiptId$ | async)">
                                                    <thead class="tight">
                                                        <tr>
                                                            <th class="date">Paid On</th>
                                                            <th class="receipt" *ngIf="displayReceiptId$ | async">Receipt</th>
                                                            <th class="payor">Payor</th>
                                                            <th class="status">Status</th>
                                                            <th class="amount numeric">Amount</th>
                                                            <th class="actions right"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let payment of bill.payments" class="payment">
                                                            <td class="date">
                                                                <ppt-paid-on [payment]="payment"></ppt-paid-on>
                                                            </td>
                                                            <td class="receipt" *ngIf="displayReceiptId$ | async">
                                                                <ng-template #receiptTemplate>
                                                                    <ppt-receipt-number [payment]="payment"></ppt-receipt-number>
                                                                </ng-template>
                                                                <div class="ellipsed" *ngIf="viewport.phone$ | async; else receiptTemplate">
                                                                    <div class="ellipsed-content" [class.loading]="!bill">
                                                                        <ng-container *ngTemplateOutlet="receiptTemplate"></ng-container>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td class="payor">
                                                                <div class="ellipsed">
                                                                    <div class="ellipsed-content" [class.loading]="!bill">
                                                                        <ppt-payor [payment]="payment"></ppt-payor>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td class="status">
                                                                <div class="ellipsed">
                                                                    <div class="ellipsed-content" [class.loading]="!bill">
                                                                        <ppt-payment-status [payment]="payment"></ppt-payment-status>
                                                                    </div>
                                                                </div>
                                                                <ng-container *ngTemplateOutlet="paymentTags; context: { $implicit: payment }"></ng-container>
                                                            </td>
                                                            <td class="amount numeric">
                                                                <ppt-payment-amount [payment]="payment"></ppt-payment-amount>
                                                            </td>
                                                            <td class="actions right align-middle">
                                                                <div class="action-buttons">
                                                                    <ng-container *ngTemplateOutlet="paymentPrintReceipt; context: { $implicit: payment }">
                                                                    </ng-container>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td [attr.colspan]="!(viewport.phone$ | async) ? 2 : 1"></td>
                                <td class="single-line right">
                                    <span class="unimportant-text">Total due</span>
                                </td>
                                <td class="single-line numeric">
                                    <ppt-account-balance
                                        [accountNumber]="accountNumber$ | async"
                                        [showYears]="false"
                                        [showDueWord]="false"
                                    ></ppt-account-balance>
                                </td>
                                <td class="total-actions actions right single-line">
                                    <app-icon-button
                                        [title]="addAccountToOrRemoveFromCartTitle$ | async"
                                        (click)="toggleAccountInCart()"
                                        [disabled]="!(addAllEnabled$ | async)"
                                        [spinner]="updatingAccountCartStatus$ | async"
                                        [style.font-size]="'24px'"
                                        [style.margin-right]="'-11px'"
                                    >
                                        {{ !(account$ | async) || !(isAccountInCart$ | async) ? "add_shopping_cart" : "remove_shopping_cart" }}
                                    </app-icon-button>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </app-show-more>
            </ng-template>
        </ng-template>
    </div>
</div>
